import { Theme, css } from '@emotion/react';
import styled from '@emotion/styled';
import { ColorType } from './Radio';
import { Direction } from './RadioGroup';

export type ColorProps = {
  colorType: ColorType;
};

const getRadioColorStyle = (colorType: ColorType, theme: Theme) => {
  switch (colorType) {
    case 'basic':
      return theme.content.hierarchy1;

    case 'brand':
    default:
      return theme.themeColor.brand;
  }
};

export const OptionWrapper = styled.div<{ direction: Direction }>`
  ${({ direction }) => css`
    display: flex;
    flex-direction: ${direction};
    gap: ${direction === 'row' ? '10px' : 'inherit'};
  `}
`;

export const Container = styled.label<ColorProps>`
  ${({ theme, colorType }) => css`
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover > span {
      border: 2px solid ${getRadioColorStyle(colorType, theme)};
    }

    &[aria-checked='true'] {
      & > span {
        border: 2px solid ${getRadioColorStyle(colorType, theme)};

        &::after {
          background: ${getRadioColorStyle(colorType, theme)};
        }
      }
    }
  `}
`;

export const Input = styled.input<ColorProps>`
  ${({ theme, colorType }) => css`
    ${theme.a11y.hidden}

    &:checked + span {
      border: 2px solid ${getRadioColorStyle(colorType, theme)};

      &::after {
        background: ${getRadioColorStyle(colorType, theme)};
      }
    }
  `}
`;

export const Maker = styled.span`
  ${({ theme }) => css`
    position: relative;
    width: 18px;
    height: 18px;
    border: 2px solid ${theme.content.caption2};
    border-radius: 50%;

    &::after {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: none;
    }
  `}
`;

export const Label = styled.p`
  ${({ theme }) => css`
    margin-left: 8px;
    color: ${theme.content.hierarchy1};
    cursor: pointer;
    ${theme.fontStyle.text.body16_regular}
  `}
`;
